import { Button } from "./button";
import { useState } from "react";
import { Menu, X } from "lucide-react";

export const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="bg-primary flex justify-center items-center w-full p-3 text-white z-50">
      <div className="w-full flex justify-between items-center lg:max-w-screen-md xl:max-w-screen-lg 2xl:max-w-screen-2xl z-50">
        <img
          src={require("../assets/prof-historia.png")}
          alt="Logo"
          className="h-10"
        />

        {/* Mobile Menu Button */}
        <button className="md:hidden p-2" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <X className="size-6" /> : <Menu className="size-6" />}
        </button>

        {/* Navigation */}
        <nav
          className={`z-50 absolute md:static top-14 left-0 w-full md:w-auto bg-primary md:bg-transparent md:flex md:items-center md:space-x-6 text-sm p-5 md:p-0 transition-all duration-300 ease-in-out ${
            isOpen ? "block opacity-75" : "hidden"
          }`}
        >
          <ul className="flex flex-col md:flex-row md:items-center md:space-x-5 text-center font-bold md:text-left z-50 ">
            <li className="py-2 md:py-0 transition duration-500 ease-in-out relative group">
              <a href="#inicio">Início</a>
              <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-white transition-all duration-300 group-hover:w-full"></span>
            </li>
            <li className="py-2 md:py-0 transition duration-500 ease-in-out relative group">
              <a href="#sobre">Sobre</a>
              <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-white transition-all duration-300 group-hover:w-full"></span>
            </li>
            <li className="py-2 md:py-0 transition duration-500 ease-in-out relative group">
              <a href="#habilidades">Habilidades</a>
              <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-white transition-all duration-300 group-hover:w-full"></span>
            </li>
            <li className="py-2 md:py-0 transition duration-500 ease-in-out relative group">
              <a href="#taxonomia">Taxonomia</a>
              <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-white transition-all duration-300 group-hover:w-full"></span>
            </li>
            <li className="py-2 md:py-0 transition duration-500 ease-in-out relative group">
              <a href="#interesses">Interesses</a>
              <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-white transition-all duration-300 group-hover:w-full"></span>
            </li>
            <li className="py-2 md:py-0 transition duration-500 ease-in-out relative group">
              <a href="#estatisticas">Estatísticas</a>
              <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-white transition-all duration-300 group-hover:w-full"></span>
            </li>
            <li className="mt-4 md:mt-0">
              <a href="#contact">
                <Button className="text-text-color">Entrar em contato</Button>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};
